<template>
    <el-container style="height: 100%;">
        <el-header style="height: 60px;" >
            <top-bar ref='meniul'/>
        </el-header>

        <el-container style="padding: 30px 20px;" >
            <el-main style="text-align:left; padding: 0px;" v-loading='loadingVisible' >
                <slot/>
            </el-main>
        </el-container>
    </el-container>

</template>

<script>
    import settings from "../../backend/LocalSettings";
    import TopBar from '@/widgets/TopBar';


    export default {
        name: "base-page",
        components: {
            'top-bar' : TopBar
        },
        data () {
            return {
                loadingVisible: false,
                notificari_noi: [],
            }
        },
        methods: {
            post: async function(url, args={}){
                this.loadingVisible      = true;
                var             response = await this.$http.post(url, args );
                this.loadingVisible      = false;
                if( settings.verify_response(response) )
                {
                    return response.body;
                } else {
                    if(response.body.loginPeAltDevice == 1){

                       await this.$router.push("/").catch(()=>{});
                       await this.$message({type:'warning', message:"Acest user s-a logat pe alt dispozitiv!"});                    
                    } else {
                        this.$router.push("/").catch(()=>{});
                    }
                }
            },
            get: async function(url, args={}){
                this.loadingVisible      = true;
                var             response = await this.$http.get(url, args );
                this.loadingVisible      = false;
                if( settings.verify_response(response) )
                {
                    return response.body;
                } else {
                    if(response.body.loginPeAltDevice == 1){

                       await this.$router.push("/").catch(()=>{});
                       await this.$message({type:'warning', message:"Acest user s-a logat pe alt dispozitiv!"});                    
                    } else {
                        this.$router.push("/").catch(()=>{});
                    }
                }
            },
            
            confirma: async function (notif) {
                console.log(notif);
                let rasp = await this.post("admin/produse/confirma_notificare", {id: notif.Id});
                if(rasp.success){
                    return true;
                } else return false;
            },
            select_menu_item(name){
                var menu  = document.getElementsByClassName('menu-bar').item(0);
                var items = menu.getElementsByTagName("li");
                for( var i = 0; i < items.length; i++ ){
                    var item = items.item(i);
                    item.classList.remove('active');
                    if( item.classList.contains(name) )
                    {
                        item.classList.add('active');
                    }
                };
            }
        },
        mounted: function() {
            settings.verify_login_and_redirect(this);
        }
    };
</script>

<style scoped>

</style>